/**************************************************
 * Nombre:       Escuela_Beneficios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import iso from "../../../Recursos/iso_azul.svg";
import {NEGRITA} from "../../../Constantes";
import Tarjeta_Beneficios from "../../Tarjetas/Tarjeta_Beneficios";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../../Dialogos/Dialogo_Wass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Escuela_Beneficios = ({item}) => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Iniciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 9}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: 3,
                    height: 350
                }}

            >

                {!sCell && <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => abrir({asunto: 'Beneficios de pertenecer a la escuela de aprendizaje'})}
                        color={'secondary'}
                        startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                        Mas informacion
                    </Button>
                </Grid>
                }


            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: -36}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: sCell ? 40 : 52,
                                    fontWeight: 600,
                                    lineHeight: 1.1,
                                    textAlign: sCell ? 'center' : 'left',
                                    color: '#fff'
                                }}>
                                Beneficios de pertenecer a la escuela de necogios
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={4}
                            sx={{mt: 6}}
                        >

                            {item && item.beneficios && item.beneficios.map((it, index) => (
                                <Grid key={index + '45pd'} container size={{xs: 12, sm: 12, md: 4}}
                                      sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Beneficios item={it}/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Escuela_Beneficios
